<template>
  <div class="suggested-card-on-page" flat>
    <slot />
    <Hooper
      ref="slides"
      :center-mode="$voicer.isMobile ? true : false"
      :infinite-scroll="true"
      :wheel-control="true"
      :items-to-show="$voicer.isMobile ? 1.05 : 3"
      class="hooper"
    >
      <HooperPagination
        slot="hooper-addons"
        class="hooper-pagination"
      ></HooperPagination>
      <Slide v-for="(item, index) in contents" :key="index">
        <v-card
          flat
          class="ma-0 pa-0 suggested-carousel-slide"
          @click="launch(item)"
        >
          <div v-if="item.isSuggested">
            <v-chip
              label
              color="primary"
              text-color="white"
              class="suggested-chip"
            >
              <v-icon right small class="ml-0 mr-1">mdi-pin</v-icon>
              {{ $t('glob_recommend') }}
            </v-chip>
          </div>
          <v-img
            v-if="item.metadatas.cards"
            :lazy-src="getCaption(item.metadatas.cards[0]).lazySrc"
            :src="getCaption(item.metadatas.cards[0]).cdnSrc"
            aspect-ratio="1"
            class="suggested-carousel-image"
          ></v-img>
          <v-img
            v-else
            :lazy-src="getCaption(item.metadatas.heading).lazySrc"
            :src="getCaption(item.metadatas.heading).cdnSrc"
            aspect-ratio="1"
            class="suggested-carousel-image"
          ></v-img>

          <div class="ma-0">
            <c-heading-card-description :is-listen="true" :content="item" />
          </div>
        </v-card>
      </Slide>
    </Hooper>
    <c-slide-control-prev class="c-slideprev" @prev="handleSlidePrev" />
    <c-slide-control-next class="c-slidenext" @next="handleSlideNext" />
  </div>
</template>

<script>
import { Hooper, Slide, Pagination as HooperPagination } from 'hooper'
import CHeadingCardDescription from '../CHeadingCard/description'
import CSlideControlNext from '../CInnerSlide/CSlideControlNext'
import CSlideControlPrev from '../CInnerSlide/CSlideControlPrev'
import _mixin from './_mixin'
import { getCaption } from '~/@mediam/spoke-js/utils/getters'

export default {
  components: {
    CHeadingCardDescription,
    CSlideControlNext,
    CSlideControlPrev,
    Hooper,
    Slide,
    HooperPagination,
  },
  mixins: [_mixin],
  methods: {
    getCaption(meta) {
      return getCaption(meta)
    },
    launch(item) {
      this.$emit('launch', item)
    },
  },
}
</script>

<style lang="scss">
.suggested-card-on-page {
  position: relative;

  .hooper {
    position: relative;
    height: auto !important;
  }
  .hooper-pagination {
    position: relative;
    justify-content: center;
    margin-top: 10px;
  }

  .hooper-indicator {
    background-color: #cfcfcf;
    width: 15px;
    height: 8px;
    margin: 5px;
    border-radius: 10px;
    transition: background-color 0.3s;
  }

  .hooper-indicator:hover,
  .hooper-indicator.is-active {
    background-color: var(--v-primary-base);
  }

  .c-slidenext {
    position: absolute;
    right: -20px;
    top: 20%;
    z-index: 20;
  }

  .c-slideprev {
    position: absolute;
    left: -20px;
    top: 20%;
    z-index: 20;
  }

  .suggested-carousel-slide {
    margin: 15px 5px 0 5px !important;
    cursor: pointer;
    .suggested-chip {
      border-radius: 10px;
      position: absolute;
      top: -15px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 20;
    }
    .suggested-carousel-image {
      border-radius: 20px !important;
      max-height: 233px !important;

      @media (max-width: 600px) {
        max-height: 200px !important;
        max-width: 200px !important;
      }
      object-fit: cover;
    }
  }
}
</style>
